var map = {
	"./vendor_logo1.png": "6c0e",
	"./vendor_logo10.png": "7a02",
	"./vendor_logo2.png": "8077",
	"./vendor_logo3.png": "d506",
	"./vendor_logo4.png": "4ab5",
	"./vendor_logo5.png": "297e",
	"./vendor_logo6.png": "723c",
	"./vendor_logo7.png": "544c",
	"./vendor_logo8.png": "3b30",
	"./vendor_logo9.png": "3bc2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5787";